import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DirectServiceRatesService } from '../services/direct-service-rates.service';

@Component({
  selector: 'app-direct-service-rates',
  templateUrl: './direct-service-rates.component.html',
  styleUrls: ['./direct-service-rates.component.css']
})
export class DirectServiceRatesComponent implements OnInit {

  isLoadingResults: boolean = false;
  
  constructor(private api: DirectServiceRatesService, private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  ImportDirectServiceRates() {
    this.isLoadingResults = true;
    this.api.ImportDirectServiceRates().subscribe(data => {
      
      if (data.statusCode == 200) {
        this.toastr.success(data["message"]);
      }
      this.isLoadingResults = false;
    }, err => {
      
      console.log(err);
      this.toastr.error(err)
      this.isLoadingResults = false;
    });
  }

}
